<ng-container *ngIf="!to.data.readOnly">
	<div #htmlContainer contenteditable="true" [(innerHTML)]="fieldValue" (keyup)="onKeyUp()"
		class="input html-editor-style">
	</div>
</ng-container>

<ng-container *ngIf="to.data.readOnly">
	<div #htmlContainer [innerHTML]="fieldValue" class="input html-editor-style">
	</div>
</ng-container>